import { getName } from 'country-list';

export const esgCoverageToTableParser = (data) =>
  data.map(
    ({
      eScore,
      sScore,
      gScore,
      esgScore,
      industryName,
      scopeoneIdentifier,
      scopeOneCompanyName,
      country,
      subscribed,
    }) => {
      const countryName = getName(country) || country;

      const esgId = scopeoneIdentifier;
      const requestState = subscribed ? 'DONE_BY_SCOPE' : '';
      const wasPurchased = subscribed;
      const isin = '';
      const requestDate = '';
      const artifactId = '';

      return [
        scopeoneIdentifier || esgId,
        [scopeOneCompanyName, requestState],
        countryName || '-',
        industryName || '-',
        [eScore || '-', requestState],
        [sScore || '-', requestState],
        [gScore || '-', requestState],
        [
          {
            id: scopeoneIdentifier,
            isin,
            esgId,
            totalScore: esgScore && typeof esgScore === 'number' ? esgScore.toFixed(1) : '-',
            scopeOneCompanyName,
            wasPurchased,
          },
          requestState,
          requestDate,
        ],
        wasPurchased,
        [scopeoneIdentifier, esgId, artifactId],
      ];
    },
  );
